import React from 'react';
import type { AppState } from '../types';
import { PageShell, glassLight, EmptyState, usePagination, Pagination, T } from '../ui';
export function Auditoria({
  state
}: {
  state: AppState;
}) {
  // state.audit ya viene con el más reciente primero.
  const events = state.audit;
  const {
    page,
    setPage,
    totalPages,
    pageItems,
    rangeStart,
    rangeEnd,
    total
  } = usePagination(events, 12);
  return <PageShell title="Auditoría" sub="Log de acciones y cambios del sistema" data-id="element-137" data-mp="1gvbik8hp44ez">
      <style data-id="element-138" data-mp="1kvvi1ipqrk4a">{`
        .aud-row { display: flex; gap: 14px; align-items: flex-start; padding: 13px 18px; border-bottom: 1px solid ${T.border}; transition: background .15s; animation: fadeUp .3s ease both; }
        .aud-row:last-child { border-bottom: none; }
        .aud-row:hover { background: rgba(255,255,255,.04); }
      `}</style>

      {events.length === 0 ? <EmptyState title="Sin eventos registrados" hint="Las acciones y cambios del sistema aparecerán aquí en cuanto ocurran." icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" data-id="element-140" data-mp="3siw438f3i22a">
          
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" data-id="element-141" data-mp="3ok6ttopct0mv" />
              <polyline points="14 2 14 8 20 8" data-id="element-142" data-mp="6a4ksm5zrw7n" />
              <line x1="16" y1="13" x2="8" y2="13" data-id="element-143" data-mp="1cuyvghta2ok" />
              <line x1="16" y1="17" x2="8" y2="17" data-id="element-144" data-mp="1f7gfsjnqb13" />
            </svg>} data-id="element-139" data-mp="3roeazsafcr3j" /> : <div style={{
      ...glassLight,
      overflow: 'hidden'
    }} data-id="element-145" data-mp="fbkwcx8jm4dg">
        
          <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '13px 18px',
        background: T.surfaceSubtle,
        borderBottom: `1px solid ${T.border}`
      }} data-id="element-146" data-mp="bc3mzspzwn30">
          
            <span style={{
          fontSize: 10,
          color: T.textMuted,
          fontWeight: 700,
          letterSpacing: '.1em',
          textTransform: 'uppercase'
        }} data-id="element-147" data-mp="k5ylihwm3f9o">
            
              Eventos
            </span>
            <span style={{
          fontSize: 11,
          fontWeight: 700,
          color: T.accent
        }} data-id="element-148" data-mp="1161edhx8crp8">
            
              {events.length} registro{events.length !== 1 ? 's' : ''}
            </span>
          </div>
          {pageItems.map((item, i) => <div key={i} className="aud-row" style={{
        animationDelay: `${Math.min(i * 0.03, 0.4)}s`
      }} data-id="element-149" data-mp="1ftw6ox7bsu1s" data-mpi={i}>
          
              <span style={{
          flexShrink: 0,
          marginTop: 5,
          width: 8,
          height: 8,
          borderRadius: '50%',
          background: T.accent,
          boxShadow: `0 0 8px ${T.accent}`
        }} data-id="element-150" data-mp="1ktqx6zn6vhmb" />
          
              <span style={{
          fontSize: 13,
          color: T.text,
          lineHeight: 1.5,
          fontWeight: 500
        }} data-id="element-151" data-mp="1trkrk51e816u">
            
                {item}
              </span>
            </div>)}
          <div style={{
        padding: '4px 18px 14px'
      }} data-id="element-152" data-mp="4epqhwed1rn5">
          
            <Pagination page={page} totalPages={totalPages} onChange={setPage} rangeStart={rangeStart} rangeEnd={rangeEnd} total={total} label="eventos" data-id="element-153" data-mp="4gts27oseek9" />
          
          </div>
        </div>}
    </PageShell>;
}